/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import { Text } from '../../../uiold';
import { themeColors } from '../../../uiold/Constants';
import LoadingIndicator from '../../../uiold/LoadingIndicator';
import connectData, { ConnectedProps } from '../../../../support/connectData';
import formatDate from '../../../../core/support/formatDate';

type Props = {
  definition: ObjectOf<any>;
  isAdmin: boolean;
  value: ObjectOf<Array<string>>;
};

class MarketSelectorReadOnlyView extends Component<FullProps> {
  static defaultProps = {
    value: {},
  };

  render() {
    let { isAdmin, isLoading, markets, value } = this.props;
    if (isLoading || !markets) {
      return (
        <div className="pull-left">
          <LoadingIndicator />
        </div>
      );
    }
    let visibleMarkets =
      isAdmin === true ? markets : markets.filter((market) => !market.hidden);
    let marketItems: Array<React.ReactElement> = [];
    let selectedDatesByMarketID = value || {};
    visibleMarkets.forEach((market) => {
      let { id, dates } = market;
      let selectedDates = new Set(selectedDatesByMarketID[id]);
      if (selectedDates.size === 0) {
        return;
      }
      let dateItems: Array<React.ReactElement> = [];
      for (let date of dates) {
        if (selectedDates.has(date)) {
          dateItems.push(
            <Text type="label" key={date}>
              {formatDate(date, { fromUTC: true, includeDayOfWeek: true })}
            </Text>,
          );
        }
      }
      marketItems.push(
        <View key={id} style={styles.container}>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.marketTitle} type="label">
              {market.name}
            </Text>
            <Text type="label" style={styles.datesNumber}>
              ({dateItems.length} {dateItems.length > 1 ? 'dates' : 'date'})
            </Text>
          </View>
          <View style={styles.flexRow}>
            {dateItems.map((el, key) => (
              <View style={styles.dateItem} key={key}>
                {el}
              </View>
            ))}
          </View>
        </View>,
      );
    });
    if (marketItems.length === 0) {
      return <span className="empty-state">(No markets selected)</span>;
    } else {
      return <div className="markets">{marketItems}</div>;
    }
  }
}

let styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  marketTitle: {
    color: themeColors.mainNavBackground,
    marginVertical: 8,
    fontWeight: '600',
    maxWidth: '70%',
  },
  datesNumber: {
    color: themeColors.mainNavText,
    marginVertical: 8,
    marginHorizontal: 4,
  },
  flexRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  dateItem: {
    width: 120,
    marginVertical: 10,
    marginHorizontal: 10,
  },
});

const connector = connectData<Props>()(() => ({
  markets: {
    dataStoreKey: 'markets',
    shouldFetch: (dataStore, resolvedKey) => {
      return dataStore.get(resolvedKey as any) == null;
    },
  },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(MarketSelectorReadOnlyView);
